import React from "react";
import { MessageCircle, Zap } from "lucide-react";
import { Link } from "react-router-dom";

export default function FloatingActions() {
  return (
    <>
      {/* Sticky check rates pill (desktop) — utility link, no urgency copy */}
      <div className="hidden lg:block fixed bottom-6 left-6 z-40">
        <Link
          to="/rates"
          className="glass rounded-full px-5 py-3 shadow-xl flex items-center gap-2 text-sm font-medium text-[#0B3C5D] hover:scale-105 transition-transform border border-white/60"
          data-testid="floating-check-rates"
        >
          <Zap className="w-4 h-4 text-[#00C853]" />
          Check Rates
        </Link>
      </div>
    </>
  );
}
